/**
 * @generated SignedSource<<ac257e144b76761b5589e6ac3ec7283e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "morningStudioContentItemContent";
};
export type morningStudioContentItemContent$key = {
  readonly " $data"?: morningStudioContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "morningStudioContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "bbb53cdcf07d54249bc6abdbe4a1e170";

export default node;
